import { Pipe, PipeTransform } from '@angular/core';
import { WtfUtils } from '../../others/core/wtfUtils';

@Pipe({name: 'filter'})
export class FilterPipe implements PipeTransform
{
    transform(mainArr: any[], searchText: string, property: string): any
    {
        return WtfUtils.filterArrayByString(mainArr, searchText);
    }
}
